import { Pagination, paginationToParams } from '../Pagination';

export interface GetProductReviewsRequest extends Pagination {
  productID: number;
}

export const getProductReviewsRequestToParams = (
  request: GetProductReviewsRequest,
) => ({
  product_id: request.productID,
  ...paginationToParams(request),
});
